module.exports = __webpack_public_path__ + "img/en.f57c3f83.png";